export default "__VITE_ASSET__BWtWWVhb__"